@if (isIconEnabled) {
    <div class="column" [ngClass]="isIceHockeyPowerPlay() ? 'serving' : 'score score-icon'">
        @for (i of [0, 1]; track i) {
            <div class="cell" [class.invisibility]="hideIcon(i)">
                @if (isIceHockeyPowerPlay()) {
                    <span class="sports-sb-pp-icon">
                        <vn-icon name="{{ icon() }}" height="9" width="12" />
                    </span>
                } @else if (isFotballSportsId()) {
                    <span class="sports-sb-fooball-icon"><vn-icon name="{{ icon() }}" size="12" /></span>
                }
            </div>
        }
    </div>
}

@if (score()) {
    <div class="column score">
        <div class="cell">
            <div [msValueSlider]="score().participant1.total.toString()"></div>
        </div>
        <div class="cell">
            <div [msValueSlider]="score().participant2.total.toString()"></div>
        </div>
    </div>
}
